if (!customElements.get('swiper-carousel')) {
  customElements.define(
    'swiper-carousel',
    class SwiperCarousel extends HTMLElement {
      constructor() {
        super();
        this.swiperEl = this.querySelector(`#${this.id} > .swiper`);
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        try {
          this.setupSwiperParams();
          console.log('Initializing Swiper with params:', this.swiperParams);
          this.swiperInstance = new Swiper(this.swiperEl, this.swiperParams);

          // Show the carousel once Swiper is ready
          this.classList.add('swiper-ready');
        } catch (error) {
          console.error('Failed to initialize Swiper:', error);
          // Show anyway if initialization fails
          this.classList.add('swiper-ready');
        }
      }

      setupSwiperParams() {
        const element = this;

        // Get slide counts for calculations
        const mobileSlides = Number(this.getAttribute('slides-per-view-mobile')) || 1;
        const tabletSlides = Number(this.getAttribute('slides-per-view-tablet')) || 3;
        const desktopSlides = Number(this.getAttribute('slides-per-view-desktop')) || 3;

        // Count total slides
        const totalSlides = this.querySelectorAll('.swiper-slide').length;


        this.swiperParams = {
          allowTouchMove: this.getAttribute('allow-touch-move-mobile') === 'true',
          observer: true,
          resizeObserver: true,
          roundLengths: true,
          centeredSlides: this.getAttribute('center-slides-mobile') === 'true',
          initialSlide: Number(this.getAttribute('initial-slide-mobile')) || 0,
          // slidesOffsetBefore: this.getAttribute("slides-offset-before-mobile") ? Number(this.getAttribute("slides-offset-before-mobile")) : 0,
          // slidesOffsetAfter: this.getAttribute("slides-offset-after-mobile") ? Number(this.getAttribute("slides-offset-after-mobile")) : 0,
          slidesPerView:
            this.getAttribute('slides-per-view-auto-mobile') === 'true'
              ? 'auto'
              : Number(this.getAttribute('slides-per-view-mobile')),
          spaceBetween: Number(this.getAttribute('space-between-mobile')),
          loop: this.getAttribute('loop-slides-mobile') === 'true',

          ...(this.getAttribute('show-navigation-buttons-mobile') === 'true' && {
            navigation: {
              nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
              prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
            },
          }),

          breakpoints: {
            768: {
              centeredSlides: this.getAttribute('center-slides-tablet') === 'true',
              allowTouchMove: this.getAttribute('allow-touch-move-tablet') === 'true',
              initialSlide: Number(this.getAttribute('initial-slide-tablet')) || 0,
              slidesPerView:
                this.getAttribute('slides-per-view-auto-tablet') === 'true'
                  ? 'auto'
                  : Number(this.getAttribute('slides-per-view-tablet')),
              spaceBetween: Number(this.getAttribute('space-between-tablet')),
              loop: this.getAttribute('loop-slides-tablet') === 'true',

              ...(this.getAttribute('show-navigation-buttons-tablet') === 'true' && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              ...(this.getAttribute('show-scrollbar-tablet') === 'true' && {
                scrollbar: {
                  el: `#${this.id} > .swiper-scrollbar`,
                  draggable: true,
                  snapOnRelease: true,
                },
              }),
            },
            990: {
              centeredSlides: this.getAttribute('center-slides-desktop') === 'true',
              allowTouchMove: this.getAttribute('allow-touch-move-desktop') === 'true',
              initialSlide: Number(this.getAttribute('initial-slide-desktop')) || 0,
              slidesPerView:
                this.getAttribute('slides-per-view-auto-desktop') === 'true'
                  ? 'auto'
                  : Number(this.getAttribute('slides-per-view-desktop')),
              spaceBetween: Number(this.getAttribute('space-between-desktop')),
              loop: this.getAttribute('loop-slides-desktop') === 'true',

              ...(this.getAttribute('show-navigation-buttons-desktop') === 'true' && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              // ...(this.getAttribute("show-scrollbar") === "true" && {
              //   scrollbar: {
              //     el: `#${this.id} > .swiper-scrollbar`,
              //     draggable: true,
              //     snapOnRelease: true
              //   },
              // }),
            },
          },
          on: {
            init(swiper) {
              console.log(`Swiper initialized: ${totalSlides} total slides, current breakpoint slides per view: ${swiper.params.slidesPerView}, centered: ${swiper.params.centeredSlides}, initial slide: ${swiper.activeIndex}`);
              // element.updateNavigationState(swiper);
              // Dispatch custom event for other components to listen
              document.dispatchEvent(new CustomEvent('swiperInit', {
                detail: { swiper: swiper, element: element }
              }));
            },
            resize(swiper) {
              // element.updateNavigationState(swiper);
            },
            update(swiper) {
              // element.updateNavigationState(swiper);
            },
          },
        };
        console.log(this.swiperParams
        )
      }

      updateNavigationState(swiper) {
        const isAuto = swiper.params.slidesPerView === 'auto';

        if (isAuto) {
          let totalSlidesWidth = 0;
          swiper.slides.forEach((slide) => {
            totalSlidesWidth += slide.offsetWidth + swiper.params.spaceBetween;
          });

          const fitsInContainer =
            totalSlidesWidth - swiper.params.spaceBetween <= swiper.width - swiper.params.slidesOffsetBefore;

          if (fitsInContainer) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }
        } else {
          const numberOfSlides = swiper.slides.length;

          if (numberOfSlides <= swiper.params.slidesPerView) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }
        }

        // Disable prev button on first slide
        if (swiper.navigation?.prevEl) {
          if (swiper.activeIndex === 0) {
            swiper.navigation.prevEl.classList.add('swiper-button-disabled');
          } else {
            swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
          }
        }
      }

      disableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.add('swiper-button-disabled');
          swiper.navigation.prevEl.classList.add('swiper-button-disabled');
        }
      }

      enableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
          swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
        }
      }
    }
  );
}
